var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page_title"},[_c('i',{staticClass:"el-icon-arrow-left",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.back()}}}),_vm._v(" "+_vm._s(_vm.$i18n.t('empower.text89'))+" ")]),_c('div',{staticClass:"body"},[_c('authorization-msg',{staticClass:"auth_msg"}),_c('device-sign-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }